import styled from "styled-components";

export const WaveformContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 100%;
  background: transparent;
  gap: 8px;
`;

export const Wave = styled.div`
  width: 100%;
  height: 30px;
`;

export const PlayButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  background: #efefef;
  border-radius: 50%;
  border: none;
  outline: none;
  cursor: pointer;
  padding-bottom: 3px;

  &:hover {
    background: #ddd;
  }
`;